import SelectedApplicant from 'components/applicant/SelectedApplicant';
import ErrorBoundary from 'components/ErrorBoundary';
import {
  addEntries,
  updateLessonsAction,
  updateLessonPausesAction,
  findApplicantsAction,
  changePage,
  resetDrivingApplicants,
  findApplicantLessonsAction,
  resetLessonEntriesAction,
  updateApplicantSearchTermsAction
} from 'ducks/drivingLessons';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'rebass';
import { bindActionCreators } from 'redux';
import NotFound404 from 'components/NotFound404';
import hasRole from 'util/hasRole';
import { DRIVING_BOOKING_APPLICANTS } from '../search/SearchType';
import Applicants from './Applicants';
import Lessons from './Lessons';
import { resetWorkItem } from 'ducks/workItem';
import { combineCourseToTerms } from '../../util/SearchUtil';

class DrivingLessons extends React.Component {

  save = (payload) => {
    this.props.addEntries(payload);
  };
  selectedApplicantPreviousFn = () => {
    this.props.resetWorkItem();
  };

  componentWillUnmount() {
    this.props.resetDrivingApplicants();
    this.props.resetWorkItem();
  }

  render() {
    const anyErrors = () => {
      let hasErrors = false;
      this.props.lessons.forEach((l) => {
        if(Object.keys(l.errors).length > 0){
          hasErrors = true;
          return hasErrors;
        }

        if(!!l.lessonPauses) {
          l.lessonPauses.forEach((lp) => {
            if(Object.keys(lp.errors).length > 0) {
              hasErrors = true;
              return hasErrors;
            }
          });
        }
      });
      return hasErrors;
    };

    const {
      applicants,
      changePage,
      lessons,
      loading,
      loggedUser,
      selectedApplicant,
      workItemLoading,
      workItemError,
      page,
      resetWorkItem,
      findApplicants,
      findApplicantLessons,
      availableLessons,
      resetLessonEntries,
      searchTerms,
      updateApplicantSearchTerms,
      placeHolderSearchTerms,
      lessonTopics,
      currentCourse,
      courseExamClasses,
    } = this.props;

    const isAllowed = hasRole(loggedUser, ['KULTU_SEURANTA_ADMIN', 'KULTU_SEURANTA_KIRJAAJA']);

    if (isAllowed) {
      return (
        <Container
          mb={!selectedApplicant.applicant ? [8, 8, 7] : 0}
          textAlign='center'>
          <ErrorBoundary>

            {page === 'APPLICANTS' && !selectedApplicant.applicant &&
              <Applicants applicants={applicants}
                loadingApplicants={loading.applicants}
                searchType={DRIVING_BOOKING_APPLICANTS}
                unitPlaceholder={!!loggedUser ? loggedUser.office : ''}
                searchApplicants={findApplicants}
                nextFn={(id) => { findApplicantLessons({ ...id, course: currentCourse }); changePage('LESSONS') }}
                nextDisabled={!!applicants ? applicants.filter(a => a.selected).length === 0 : true}
                searchTerms={searchTerms}
                updateApplicantSearchTerms={updateApplicantSearchTerms}
                currentCourse={currentCourse}
                placeHolderSearchTerms={placeHolderSearchTerms}
            />
            }
            {page === 'LESSONS' &&
              <Lessons lessons={lessons}
                generalLoading={this.props.generalLoading}
                nextFn={this.save}
                nextDisabled={!lessons || lessons.length === 0 || anyErrors()}
                previousFn={() => changePage('APPLICANTS') && resetLessonEntries() && resetWorkItem()}
                updateLessons={this.props.updateLessons}
                updateLessonPauses={this.props.updateLessonPauses}
                pauseTypes={this.props.pauseTypes}
                availableLessons={availableLessons}
                selectedApplicants={!!applicants ? applicants.filter(a => a.selected) : []}
                lessonTopics={lessonTopics}
                currentCourse={currentCourse}
                courseExamClasses={courseExamClasses}
              
            />
            }
            {!!selectedApplicant.applicant &&
            <SelectedApplicant
              {...selectedApplicant}
              error={workItemError}
              loading={workItemLoading}
              previousFn={this.selectedApplicantPreviousFn} />
            }
          </ErrorBoundary>
        </Container>
      );
    } else {
      return <NotFound404 message={!isAllowed && 'app.missing_perm'} />;
    }
  }
}

DrivingLessons.propTypes = {
  applicants: PropTypes.array,
  lessons: PropTypes.array,
  updateLessons: PropTypes.func,
  updateLessonPauses: PropTypes.func,
  pauseTypes: PropTypes.array,
  addEntries: PropTypes.func,
  error: PropTypes.object,
  loading: PropTypes.object,
  loggedUser: PropTypes.object,
  findLessons: PropTypes.func,
  resetDrivingApplicants: PropTypes.func,
  resetWorkItem: PropTypes.func,
  page: PropTypes.string,
  selectedApplicant: PropTypes.object,
  workItemLoading: PropTypes.bool,
  workItemError: PropTypes.object,
  searchApplicants: PropTypes.func,
  searchTerms: PropTypes.object,
  updateApplicantSearchTerms: PropTypes.func,
  availableLessons: PropTypes.array,
  courseExamClasses: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    applicants: state.drivingLessons.applicants,
    availableLessons: state.drivingLessons.applicantLessons,
    lessons: state.drivingLessons.lessons,
    loading: state.drivingLessons.loading,
    pauseTypes: state.general.lessonPauseTypes,
    generalLoading: state.general.loading,
    selectedApplicant: state.workItem.selectedApplicant,
    page: state.drivingLessons.page,
    workItemLoading: state.workItem.loading,
    workItemError: state.workItem.error,
    loggedUser: state.userState.user,
    currentCourse: state.userState.currentCourse,
    searchTerms: combineCourseToTerms(state.drivingLessons.applicantSearchTerms, state.userState.currentCourse),
    placeHolderSearchTerms: !state.drivingLessons.searchTermsUpdated,
    lessonTopics: state.general.drivingLessonTopics,
    courseExamClasses: state.userState.courseData.examClasses,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  updateLessons: (lessons) => updateLessonsAction(lessons),
  updateLessonPauses: (data) => updateLessonPausesAction(data),
  addEntries: (payload) => addEntries(payload),
  findApplicants: (searchTerms) => findApplicantsAction(searchTerms),
  resetDrivingApplicants: () => resetDrivingApplicants(),
  resetWorkItem: () => resetWorkItem(),
  changePage: (page) => changePage(page),
  findApplicantLessons: (id) => findApplicantLessonsAction(id),
  resetLessonEntries: () => resetLessonEntriesAction(),
  updateApplicantSearchTerms: (searchTerm) => updateApplicantSearchTermsAction(searchTerm),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DrivingLessons);



// WEBPACK FOOTER //
// ./src/containers/driving/index.js